<template>
  <div class="content-top-padding" v-cloak>
    <div class="container-fluid">
      <div class="row d-flex justify-content-center landing-bg position-relative">
        <video
          id="myvideo"
          autoplay
          muted
          loop
          playsinline
          class="landing-video-DT d-none d-md-block"
        >
          <source src="@/assets/01/landing_1920x940-v4.mp4" type="video/mp4" />
        </video>
        <canvas id="mycanvas" class="d-none d-md-block"></canvas>

        <video autoplay muted loop playsinline class="landing-video-MB d-md-none">
          <source src="@/assets/01/landing_750x800-v2.mp4" type="video/mp4" />
        </video>
      </div>
      <LandingDirectory />
    </div>
  </div>
</template>

<script>
import LandingDirectory from "@/components/LandingDirectory.vue";

export default {
  name: "Landing",
  components: { LandingDirectory },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Home",
    // all titles will be injected into this template
    titleTemplate: "%s - HKTB Annual Report 2020/21",
  },
  methods: {},
  mounted() {
    let canvas = document.querySelector("#mycanvas");
    let ctx = mycanvas.getContext("2d");
    let video = document.querySelector("#myvideo");

    // set canvas size = video size when known
    video.addEventListener("loadedmetadata", function() {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
    });

    video.addEventListener(
      "play",
      function() {
        let $this = this; //cache
        (function loop() {
          if (!$this.paused && !$this.ended) {
            ctx.drawImage($this, 0, 0);
            setTimeout(loop, 1000 / 30); // drawing at 30fps
          }
        })();
      },
      0
    );
  },
};
</script>

<style lang="scss" scoped>
#myvideo {
  pointer-events: none;
  opacity: 0.01;
}
#mycanvas {
  position: absolute;
  max-width: 90%;
}
.landing-bg {
  overflow: hidden;
  background-color: #ea3e00;
}
.landing-video-DT {
  max-width: 90%;
  z-index: 1;
}
.landing-video-MB {
  max-width: 100%;
}
</style>
